export default __webpack_public_path__ + "static/media/3d_card2.f390876c.png";